import {
  RadioGroup as KendoRadioGroup,
  RadioGroupChangeEvent,
  RadioGroupProps,
} from '@progress/kendo-react-inputs';
import _ from 'lodash';
import { ValidationError } from '../../apps/benefit/models/Errors';
import ErrorViewer from './ErrorViewer';

interface IRadioGroupProps {
  label?: string;
  errors?: ValidationError[];
  clearErrors?: () => void;
  mandatory?: boolean;
}

const RadioGroup = (props: IRadioGroupProps & RadioGroupProps) => {
  const { label, errors, mandatory, clearErrors, onChange } = props;
  const internalOnChange = (e: RadioGroupChangeEvent) => {
    if (errors?.length) {
      clearErrors?.();
    }
    onChange?.(e);
  };
  return (
    <>
      <div className="form-options-list">
        {label && (
          <label className="radio-group-label">
            {label}
            {mandatory && <sup>*</sup>}
          </label>
        )}
        <KendoRadioGroup
          {..._.omit(props, 'errors', 'clearErrors')}
          onChange={internalOnChange}
        />
      </div>
      <ErrorViewer errors={errors} />
    </>
  );
};

export default RadioGroup;
